export async function getUrl(id, startParams, isConfigUrl = false) {
  function getJSON(url) {
    return new Promise(function (resolve) {
      let xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'json'
      xhr.onload = function () {
        resolve(xhr.response)
      }
      xhr.send()
    })
  }
  let graphQlUrl = 'http://localhost:5000'
  if (isConfigUrl) {
    const configJSON = await getJSON(`${window.location.origin}${process.env.VUE_APP_BASE_PATH}config.json`)
    const config = window.DOCKERMODE ? configJSON.docker : configJSON.iis
    graphQlUrl = config.GraphQlUrl
  }
  graphQlUrl = graphQlUrl.startsWith('/') ? window.location.origin + graphQlUrl : graphQlUrl
  let url = new URL(`microflow/${id}`, graphQlUrl)
  if (startParams?.EventName && startParams?.PageId) {
    url.searchParams.append('pageId', startParams.PageId)
    url.searchParams.append('eventName', startParams.EventName)
  }
  return url
}


export class MicroflowApi {

  constructor({ axios }) {
    this.axios = axios
  }
  async callMicroFlow(id, startParams, properties, isConfigUrl = true) {
    let response = await this.axios.post(await getUrl(id, startParams, isConfigUrl), properties)
    return response
  }
}